import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2768abc1"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "col-12" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "รหัสพนักงาน", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"red"} }, " *", -1))
const _hoisted_4 = { class: "col-12" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "รหัสผ่าน", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"red"} }, " *", -1))
const _hoisted_7 = {
  class: "col-12",
  style: {"padding-top":"8px"}
}
const _hoisted_8 = {
  key: 0,
  class: "text-bold",
  style: {"color":"red","word-wrap":"break-word","margin-top":"12px"}
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Please update your browser or use other browser Chrome, Firefox, Opera", -1))
const _hoisted_11 = {
  class: "col-12",
  style: {"align-items":"center","justify-content":"right","display":"flex"}
}
const _hoisted_12 = {
  key: 0,
  class: "col-12 error-message"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_input = _resolveComponent("q-input")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_form = _resolveComponent("q-form")!

  return (_openBlock(), _createBlock(_component_q_form, {
    class: "q-gutter-md",
    onSubmit: $setup.onSubmit
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_q_input, {
          modelValue: $setup.formData.username,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.formData.username) = $event)),
          "label-slot": "",
          "lazy-rules": "",
          rules: [ val => val && val.length > 0 || 'กรุณาป้อนรหัสพนักงาน' ],
          filled: "",
          dense: ""
        }, {
          label: _withCtx(() => [
            _hoisted_2,
            _hoisted_3
          ]),
          _: 1
        }, 8, ["modelValue", "rules"])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_q_input, {
          modelValue: $setup.formData.password,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.formData.password) = $event)),
          "label-slot": "",
          "lazy-rules": "",
          type: $setup.isPwd ? 'password' : 'text',
          rules: [ val => val && val.length > 0 || 'กรุณาป้อนรหัสผ่าน' ],
          hint: "รหัสผ่านเดียวกับระบบ ESS",
          filled: "",
          dense: ""
        }, {
          label: _withCtx(() => [
            _hoisted_5,
            _hoisted_6
          ]),
          append: _withCtx(() => [
            _createVNode(_component_q_icon, {
              name: $setup.isPwd ? 'visibility_off' : 'visibility',
              class: "cursor-pointer",
              onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.isPwd = !$setup.isPwd))
            }, null, 8, ["name"])
          ]),
          _: 1
        }, 8, ["modelValue", "type", "rules"])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_component_q_btn, {
          label: "เข้าสู่ระบบ",
          type: "submit",
          color: "primary",
          disable: $setup.isnotSupport,
          style: {"width":"100%"}
        }, null, 8, ["disable"]),
        ($setup.isnotSupport)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _createElementVNode("span", null, "Your Browser : " + _toDisplayString($setup.browserName) + " version : " + _toDisplayString($setup.browserVersion) + " is not support.", 1),
              _hoisted_9,
              _hoisted_10
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", {
          class: "rpwd text-caption",
          onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => ($setup.resetPassword && $setup.resetPassword(...args)))
        }, "Reset Password")
      ]),
      ($setup.loginError)
        ? (_openBlock(), _createElementBlock("div", _hoisted_12, _toDisplayString($setup.loginError), 1))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["onSubmit"]))
}